// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ProductsPagination_wrap__1hr2v"};